<div class="content">
  <div class="video">
    <!-- List of videos in practice call -->
    <div class="video-pause" *ngIf="callStore.getIsPaused()">
      <div class="title">{{'call.SIMULATION_PAUSED' | transloco}}</div>
      <div class="description">
        {{'call.CLICK_RESUME' | transloco}}
      </div>
    </div>
    <ng-container *ngFor="let item of playerService?.practiceCallClips">
      <video [id]="'avatar-video-' + item.index" [src]="item.src" [className]="item.className" preload="auto" [attr.playsinline]="true"
            [attr.webkit-playsinline]="true"></video>
    </ng-container>
  </div>
</div>

<footer *ngIf="controlService && playerService" class="precall">
  <!-- Begin Call -->
  <quant-button type="button" [label]="('call.BEGIN_CALL' | transloco)" hierarchy="primary" size="lg"
    [disabled]="callStore.getIsPaused() || playerService.isBeginCallDisabled"
    (click)="(callStore.getIsPaused() || playerService.isBeginCallDisabled) ? null : playerService.beginCallFromPreCall()">
  </quant-button>

  <!-- Resume / Pause -->
  <quant-button type="button" [label]="callStore.getIsPaused() ? ('call.RESUME' | transloco) : ('call.PAUSE_LABEL' | transloco)" hierarchy="secondary-gray-dark"
    [iconLeading]="callStore.getIsPaused() ? 'assets/icons/play-circle.svg' : 'assets/icons/pause-circle.svg'" size="lg"
    (click)="handlePreCallPauseClick()">
  </quant-button>

  <!-- Leave -->
  <quant-button type="button" [label]="('call.LEAVE_CALL_BRIEFING' | transloco)" hierarchy="secondary-gray-dark" size="lg"
    (click)="controlService.viewMyAssignements()">
  </quant-button>
</footer>
